export default {
      id: "product_1_year-usage",
      viewBox: "0 0 45 45",
      url: __webpack_public_path__ + "img/icons.svg#product_1_year",
      toString: function () {
        return this.url;
      }
    }